module.exports = {XMLHttpRequest:XMLHttpRequest};